/**
 * Налаштування глядача у власному чаті ефіру: свій нік, колір і значок.
 *
 * Звичайним HTTP, а не вебсокетом: це разова дія, у неї є відповідь із
 * помилкою («нік зайнятий»), а значок — це файл, який у кадр однаково не
 * запхнеш. Сокет про зміну дізнається окремим кадром — його шле сам чат
 * (useLiveChat.refreshProfile), бо профіль на зʼєднанні інакше протухає
 * лише за 15 секунд.
 *
 * Роути чату публічні (auth: false) і розбирають токен самі — тож віддаємо
 * його заголовком, як і завантаження медіа в чат.
 */

export const useChatProfile = () => {
  const config = useRuntimeConfig()
  const token = useStrapiToken()

  const base = () => config.public.apiBase || ''
  const auth = () => ({ Authorization: `Bearer ${token.value}` })

  // Strapi кладе причину відмови в data.error.message — саме її й треба
  // показати людині («Цей нік уже зайнятий»), а не «500»
  const call = async (path, options = {}) => {
    try {
      return await $fetch(`${base()}/api/chat${path}`, { headers: auth(), ...options })
    } catch (e) {
      throw new Error(e?.data?.error?.message || 'Не вдалося зберегти')
    }
  }

  const load = async () => (await call('/profile')).profile

  /**
   * Порожній рядок означає «повернути як було за замовчуванням»: без ніка
   * чат показує твічевий логін, без кольору — рахує колір із самого імені
   */
  const save = async ({ name, color }) =>
    (await call('/profile', { method: 'PUT', body: { name, color } })).profile

  const uploadBadge = async (file) => {
    const form = new FormData()
    form.append('file', file)
    return (await call('/badge', { method: 'POST', body: form })).profile
  }

  const clearBadge = async () => (await call('/badge', { method: 'DELETE' })).profile

  return { load, save, uploadBadge, clearBadge }
}
